module.exports = __webpack_public_path__ + "static/media/discord.7b61a813.svg";